var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_17678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4571 5.25L11.3026 3.01449C11.8382 1.59724 13.428 0.5 14.936 0.5H25.064C26.5793 0.5 28.1579 1.59474 28.6953 3.01425L29.5409 5.25H36.997C38.652 5.25 40 6.59243 40 8.24V29.91C40 31.5604 38.6492 32.9 36.997 32.9H3.003C1.34854 32.9 0 31.5561 0 29.91V8.24C0 6.58962 1.35078 5.25 3.003 5.25H10.4571ZM3.003 7.25C2.45165 7.25 2 7.69792 2 8.24V29.91C2 30.45 2.45157 30.9 3.003 30.9H36.997C37.5484 30.9 38 30.4521 38 29.91V8.24C38 7.69886 37.5493 7.25 36.997 7.25H28.1591L27.9147 6.60375L26.8248 3.72211C26.5813 3.07902 25.7464 2.5 25.064 2.5H14.936C14.2593 2.5 13.4148 3.08285 13.1733 3.72175L11.8389 7.25H3.003ZM4 2.5H7C7.55228 2.5 8 2.94772 8 3.5C8 4.05228 7.55228 4.5 7 4.5H4C3.44772 4.5 3 4.05228 3 3.5C3 2.94772 3.44772 2.5 4 2.5ZM20 27.5C15.0294 27.5 11 23.4706 11 18.5C11 13.5294 15.0294 9.5 20 9.5C24.9706 9.5 29 13.5294 29 18.5C29 23.4706 24.9706 27.5 20 27.5ZM21 17.5V14.495C21 13.955 20.552 13.5 20 13.5C19.444 13.5 19 13.946 19 14.495V17.5H15.995C15.455 17.5 15 17.948 15 18.5C15 19.056 15.446 19.5 15.995 19.5H19V22.505C19 23.045 19.448 23.5 20 23.5C20.556 23.5 21 23.054 21 22.505V19.5H24.005C24.545 19.5 25 19.052 25 18.5C25 17.944 24.554 17.5 24.005 17.5H21Z",
    fill: "#A1A5B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_17678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 33,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c34dba8d.svg";
export { ForwardRef as ReactComponent };